const deg2rad = (deg: number): number => {
    return deg * (Math.PI / 180);
};

export const getDistanceFromLatLonInKm = (
    lat1: Undefinable<number>,
    lon1: Undefinable<number>,
    lat2: Undefinable<number>,
    lon2: Undefinable<number>
): Undefinable<number> => {
    if (lat1 && lon1 && lat2 && lon2) {
        const R = 6371; // Radius of the earth in km
        const dLat = deg2rad(lat2 - lat1);
        const dLon = deg2rad(lon2 - lon1);
        const a =
            Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
            Math.sin(dLon / 2) * Math.sin(dLon / 2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        const d = R * c;    // Distance in km
        return d;
    }
};
